import { BOD, ContactUs, Email, Location } from "../../../../utils/Constant";

export const userProfileData = [
    {
        icon:"envelope",
        title:Email,
        detail:"Marekjecno@yahoo.com"
    },
    {
        icon:"calendar",
        title:BOD,
        detail:"02 January 1988"
    },
    {
        icon:"phone",
        title:ContactUs,
        detail:"India +91 123-456-7890"
    },
    {
        icon:"location-arrow",
        title:Location,
        detail:"B69 Near Schoool Demo Home"
    },
]

export const tourProfileData = [
    {
        link: 'https://www.facebook.com/',
        icon: 'facebook'
    },
    {
        link: 'https://accounts.google.com/',
        icon: 'google-plus'
    },
    {
        link: 'https://twitter.com/',
        icon: 'twitter'
    },
    {
        link: 'https://www.instagram.com/',
        icon: 'instagram'
    },
    {
        link: 'https://rss.app/',
        icon: 'rss'
    }
]

export const addProjectsAndUploadData = [
    {
      date: "28 May 2024",
      status: "Completed",
      statusClass: "bg-success",
      price: "$56,908",
    },
    {
      date: "12 June 2024",
      status: "On going",
      statusClass: "bg-danger",
      price: "$45,087",
    },
    {
      date: "12 July 2024",
      status: "Pending",
      statusClass: "bg-warning",
      price: "$60,123",
    },
    {
      date: "14 June 2024",
      status: "Pending",
      statusClass: "bg-warning",
      price: "$70,435",
    },
    {
      date: "25 June 2024",
      status: "Completed",
      statusClass: "bg-success",
      price: "$15,987",
    }
  ];